import React from 'react';
import CIcon from '@coreui/icons-react';

import { AUTH_PATH, SESSION_STORAGE_GOOGLE_REDIRECT_DATA_USER, SESSION_STORAGE_GOOGLE_REDIRECT_LOGIN } from '../../constants';
import PropTypes from 'prop-types';

const Google = ({ className, isIconColor, labelButton, isFromLogin, dataUser }) => {
     const url = process.env.REACT_APP_GOOGLE_OAUTH2_URL;
     const options = {
          redirect_uri: `${window.location.origin}${AUTH_PATH.GOOGLE_LOGIN_REDIRECT}`,
          response_type: 'token',
          scope: 'email profile',
          client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
          prompt: 'select_account',
          flowName: 'GeneralOAuthFlow'
     }

     let params = '';
     Object.entries(options).forEach(([key, value], index) => {
          if (index === 0) {
               params = `${params}${key}=${value}`;
          } else {
               params = `${params}&${key}=${value}`;
          }
     })

     const onClickGoogleRedirect = () => {
          sessionStorage.setItem(SESSION_STORAGE_GOOGLE_REDIRECT_LOGIN, JSON.stringify(isFromLogin))
          sessionStorage.setItem(SESSION_STORAGE_GOOGLE_REDIRECT_DATA_USER, JSON.stringify(dataUser))
     }

     return (
          <a className={`btn ${className || 'btn-danger'} btn-lg btn-block`} style={{borderRadius: '20px'}} href={`${url}?${params}`} onClick={onClickGoogleRedirect} >
               {
                    isIconColor ? (
                         <CIcon icon="icon-google" />
                    ) : (
                         <i className="fab fa-google pr-2"></i>
                    )
               }
               <span>{labelButton}</span>
          </a>
     );
};


Google.propTypes = {
     isIconColor: PropTypes.bool,
     isFromLogin: PropTypes.bool,
     labelButton: PropTypes.any,
     className: PropTypes.string,
     dataUser: PropTypes.any,
};

export default Google;
